import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-applied-filters-count',
  templateUrl: './applied-filters-count.component.html',
  styleUrls: ['./applied-filters-count.component.scss']
})
export class AppliedFiltersCountComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialog_ref: MatDialogRef<AppliedFiltersCountComponent>

  ) { }

  ngOnInit(): void {
  }

  close() {
    this.dialog_ref.close({
      reset: 1
    });
  }

  save() {

  }

}
